import { useLocaleStore } from '../../store/locale'
import { loadingI18n } from '../../i18n/shared/loading'

import './PexifyLoader.css'

export type PexifyLoaderMode = 'bootstrap' | 'navigation' | 'static'

type PexifyLoaderProps = {
  mode?: PexifyLoaderMode
  decorative?: boolean
  className?: string
}

const ARM_PATHS = [
  'M0 0H21L47 26L36 37L0 0Z',
  'M79 0H100L64 37L53 26L79 0Z',
  'M36 43L47 54L22 79H0L36 43Z',
  'M64 43L100 79H78L53 54L64 43Z',
] as const

const CENTER_PATH = 'M50 30.5L59.5 40L50 49.5L40.5 40L50 30.5Z'

export function PexifyLoader({
  mode = 'navigation',
  decorative = false,
  className,
}: PexifyLoaderProps) {
  const locale = useLocaleStore((state) => state.locale)
  const status = loadingI18n[locale].status
  const classes = ['pexify-loader', className].filter(Boolean).join(' ')

  return (
    <div
      className={classes}
      data-mode={mode}
      data-motion={mode === 'static' ? 'static' : 'animated'}
      data-pexify-loader
      {...(decorative
        ? {}
        : {
            'aria-label': status,
            'aria-live': 'polite' as const,
            role: 'status',
          })}
    >
      <svg
        aria-hidden="true"
        className="pexify-loader__mark"
        focusable="false"
        viewBox="0 0 120 120"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="pexify-loader__tile"
          height="112"
          rx="28"
          width="112"
          x="4"
          y="4"
        />
        <g transform="translate(19 27.61) scale(.82)">
          {ARM_PATHS.map((path, index) => (
            <path
              className={`pexify-loader__arm pexify-loader__arm--${index + 1}`}
              d={path}
              data-pexify-loader-arm
              key={path}
            />
          ))}
          <path
            className="pexify-loader__center"
            d={CENTER_PATH}
            data-pexify-loader-center
          />
        </g>
      </svg>
    </div>
  )
}
